import axios from 'axios';

/**
 * When response-type is blob but we want json if there is an error.
 * > That isn't supported for the moment but you can implement it yourself
 * > specifying a custom transformResponse function.
 *
 * credit: https://github.com/axios/axios/issues/815#issuecomment-453963910
 */
export default {
  errorAsJson() {
    return axios.interceptors.response.use(this.onFulfilled, this.onRejected);
  },
  onFulfilled(response) {
    return response;
  },
  onRejected(error) {
    if (error.request.responseType !== 'blob') {
      return Promise.reject(error);
    }
    if (! error.response.data instanceof Blob) {
      return Promise.reject(error);
    }
    if (! error.response.data.type) {
      return Promise.reject(error);
    }
    if (error.response.data.type.toLowerCase().indexOf('json') === -1) {
      return Promise.reject(error);
    }

    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = () => {
        error.response.data = JSON.parse(reader.result.toString());
        resolve(Promise.reject(error));
      };

      reader.onerror = () => {
        reject(error);
      };

      reader.readAsText(error.response.data);
    });
  }
}
